export default [
    //FOR Vendor Manager==========================================================================
    {
        key: "Pending Approval Vendors",
        status: "Pending Approval Vendors",
        label: "Evaluate this Vendor and Approve or Reject it.",
        reject_reason: "",
        actionButtons: [
            {
                endPoint: "updateVendorStatus",
                payLoad: {
                    id: "", //record Id To Update
                    newStatus: "Approved Vendors",
                },

                getReason: false,//if True, a popup will show to ask user to type the reason
                rejectDialogTitle: "",
                rejectReasonMessage: "",

                buttonLabel: "Approve",
                color: 'success',
                icon: "icon-thumbs-up",
                btnSize: "large",

                confirmationTitle: "Submission",
                confirmationMessage: "Are you sure you want to Approved this Vendor?",
                successMessage: "This Vendor has been successfully Approved.",

                sucessEventName: "changeView",
                successEventValue: "list",
            },
            {
                endPoint: "updateVendorStatus",
                payLoad: {
                    id: "", //record Id To Update
                    newStatus: "Rejected Vendors",
                },

                getReason: true,//if True, a popup will show to ask user to type the reason
                rejectDialogTitle: "Reject Confirmation",
                rejectReasonMessage: "Why Are you Rejecting this Vendor?",

                buttonLabel: "Reject this Vendor",
                color: 'danger',
                icon: "icon-thumbs-down",
                btnSize: "large",

                confirmationTitle: "Rejection",
                confirmationMessage: "",
                successMessage: "This Vendor has been successfully Rejected",

                sucessEventName: "changeView",
                successEventValue: "list",
            }

        ]

    },
    {
        key: "Rejected Vendors",
        status: "Rejected Vendors",
        label: "You Rejected this Vendor.",
        reject_reason: "",
        actionButtons: [
          
        ]

    },
    {
        key: "Approved Vendors",
        status: "Approved Vendors",
        label: "This Vendor has been Approved",
        reject_reason: "",
        actionButtons: [

        ]
    },
    //------------------------------------------------------------------------------------
    //FOR Vendor==========================================================================
    {
        key: "profile",
        status: "New Vendors",
        label: "Update your Profile and Submit for Approval",
        reject_reason: "",
        actionButtons: [
            {
                endPoint: "updateVendorStatus",
                payLoad: {
                    id: "", //record Id To Update
                    newStatus: "Pending Approval Vendors",
                },

                getReason: false,//if True, a popup will show to ask user to type the reason
                rejectDialogTitle: "",
                rejectReasonMessage: "Why Are you Rejecting this PR?",

                buttonLabel: "Submit To HOD",
                color: 'success',
                icon: "icon-send",
                btnSize: "large",

                confirmationTitle: "Submission",
                confirmationMessage: "Are you sure you want to submit this to Branch HOD?",
                successMessage: "Your Application has been successfully Submitted to HOD",

                sucessEventName: "changeView",
                successEventValue: "list",
            },
        ]
    },
    {
        key: "profile",
        status: "Rejected Vendors",
        label: "Your Application has been Rejected.",
        reject_reason: "",
        actionButtons: [
            {
                endPoint: "updateVendorStatus",
                payLoad: {
                    id: "", //record Id To Update
                    newStatus: "Pending Approval Vendors",
                },

                getReason: false,//if True, a popup will show to ask user to type the reason
                rejectDialogTitle: "",
                rejectReasonMessage: "Why Are you Rejecting this PR?",

                buttonLabel: "Submit To HOD",
                color: 'success',
                icon: "icon-send",
                btnSize: "large",

                confirmationTitle: "Submission",
                confirmationMessage: "Are you sure you want to submit this to Branch HOD?",
                successMessage: "Your Application has been successfully Submitted to HOD",

                sucessEventName: "changeView",
                successEventValue: "list",
            },
        ]
    },
    {
        key: "profile",
        status: "Approved Vendors",
        label: "Your Application has been Approved.",
        reject_reason: "",
        actionButtons: [
         
        ]
    },
    {
        key: "profile",
        status: "Pending Approval Vendors",
        label: "Your Application status is Pending for Approval.",
        reject_reason: "",
        actionButtons: [

        ]
    }, 
    //------------------------------------------------------------------------------------------
]